<template>
  <div class="mod-config" style="height: 100% ">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="选择时间：">
        <el-date-picker
          v-model="dataForm.dateStr"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-button @click="getDataList()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button size="mini" icon="el-icon-back" @click="returnd()" style="font-size: 16px;"></el-button>
        <el-button size="mini" style="font-size: 16px;" @click="reload()"><i class="el-icon-loading"></i></el-button>
        <el-dropdown size="mini" placement="bottom" trigger="click" style="margin-left: 10px;">
          <el-button size="mini" class="el-icon-more-outline" style="font-size: 16px;"></el-button>
          <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
            <el-dropdown-item>新增设备通道</el-dropdown-item>
            <el-dropdown-item>删除设备通道</el-dropdown-item>
            <el-dropdown-item @click="userExcel()">导出Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 150px)"
      border
      stripe
      :header-cell-style="{background:'#FAFAFA'}" placement="top">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="40">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="ID"
        width="60">
      </el-table-column>
      <el-table-column
        prop="deviceId"
        header-align="center"
        align="center"
        label="设备ID"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="code"
        header-align="center"
        align="center"
        label="因子编码"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="因子名称">
      </el-table-column>
      <el-table-column
        prop="unit"
        header-align="center"
        align="center"
        label="单位"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="secondAlarmValue"
        header-align="center"
        align="center"
        label="一级预警值">
      </el-table-column>
      <el-table-column
        prop="firstAlarmValue"
        header-align="center"
        align="center"
        label="二级预警值">
      </el-table-column>
      <el-table-column
        prop="note"
        header-align="center"
        align="center"
        label="描述信息">
      </el-table-column>
      <el-table-column
        prop="formula"
        header-align="center"
        align="center"
        label="修正公式">
      </el-table-column>
      <el-table-column
        prop="variable"
        header-align="center"
        align="center"
        label="参数">
      </el-table-column>
      <el-table-column
        prop="type"
        header-align="center"
        align="center"
        label="类型">
        <template slot-scope="scope">
          <label v-if="scope.row.type == '0'">
            监测值
          </label>
          <label v-else>
            计算值
          </label>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        header-align="center"
        align="center"
        label="排序"
        sortable>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)"><i class="el-icon-edit-outline"
                                                                                          style="font-size: 16px;"></i>
          </el-button>
          <el-button type="text" @click="deleteHandle(scope.row.id)"><i class="el-icon-delete"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from './devicechannel-add-or-update'
import $ from 'jquery'
import {excel} from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        params: '',
        dateEnum: '',
        dateStr: '',
        dateFromStr: '',
        dateToStr: '',
      },
      addOrUpdateVisible: false,
      number: '1',
      dataList: [],
      tableHead: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      eightaveraged: {
        legend: [],
        series: [
          {
            name: "", type: "line", stack: "总量", data: [],
          }
        ],
        xaxis: [],
      },
    }
  },
  created() {
    this.getDataList("0");
  },
  methods: {
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    //格式化
    dateFormat(row, column) {
      let date = row[column.property];
      return this.$moment(date).format("YYYY年MM月DD日")
    },
    // 获取数据列表
    getDataList(type) {
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      }
      this.dataListLoading = true;
      this.dataList = [];
      this.tableHead = [];
      this.$http({
        url: this.$http.adornUrl('/deviceChannel/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'username': this.dataForm.username,
          'companyName': this.dataForm.companyName,
          'deviceId': this.$route.query.id,
          'dateFromStr': this.dataForm.dateFromStr,
          'dateToStr': this.dataForm.dateToStr,
          'dateEnum': type,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.tableHead = data.data.head;
          this.dataList = data.data.rows
          this.totalPage = data.data.total
          //重置参数
          this.dataForm.dateFromStr = '';
          this.dataForm.dateToStr = '';
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    //excel
    userExcel() {
      excel("/user/excel", "账号信息", {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'username': this.dataForm.username,
        'companyName': this.dataForm.companyName,
      })
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("/deviceChannel/delete"),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.getDataList()
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    returnd() {
      this.$router.replace({path: '/indexhome/device'});
    },
    reload() {
      this.number = '1';
      this.getDataList("0");
      //重置参数
      this.dataForm.dateStr = '';
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/devicepassagewayView.vue